import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect } from 'react';
import { useContext, useMemo, useRef } from 'react';
import without from 'lodash/without';
import values from 'lodash/values';
import { useDataActions } from '../../hooks/useDataActions';
import ConditionContext from '../ConditionContext';
export const ConditionScope = (props)=>{
    const { children, preserveContext } = props;
    const propsRef = useRef(props);
    propsRef.current = props;
    const clearableChildComponentsRef = useRef({});
    const dataActions = useDataActions();
    const ctxCondition = useContext(ConditionContext);
    const getCallbackObject = (path)=>{
        const propName = (path?.path || []).map((x)=>`${x.tableName}:${x.rowId}`).join('-') || 'root';
        if (!clearableChildComponentsRef.current) {
            clearableChildComponentsRef.current = {};
        }
        if (!clearableChildComponentsRef.current[propName]) {
            clearableChildComponentsRef.current[propName] = {
                path: path,
                callbacks: []
            };
        }
        return clearableChildComponentsRef.current[propName];
    };
    const clearCallbacks = (options)=>{
        const clearDataCallbacks = clearableChildComponentsRef.current;
        values(clearDataCallbacks).filter((x)=>x.callbacks && x.callbacks.length).forEach((x)=>{
            const { path, callbacks } = x;
            dataActions.updateRow((row)=>callbacks.reduce((r, callback)=>callback(r, options), row), {
                detachedId: path.detachedId || undefined,
                path: path.path
            });
        });
    };
    const clearCallbacksRef = useRef(clearCallbacks);
    clearCallbacksRef.current = clearCallbacks;
    const condition = useMemo(()=>{
        return {
            registerClearableComponent: (path, comp)=>{
                const cache = getCallbackObject(path);
                cache.callbacks = [
                    ...cache.callbacks,
                    comp
                ];
                if (ctxCondition) {
                    ctxCondition.registerClearableComponent(path, comp);
                }
            },
            unregisterClearableComponent: (path, comp)=>{
                const cache = getCallbackObject(path);
                cache.callbacks = without(cache.callbacks, comp);
                if (ctxCondition) {
                    ctxCondition.unregisterClearableComponent(path, comp);
                }
            },
            preserveContext: !!preserveContext,
            clear: ()=>{
                clearCallbacksRef.current({
                    washField: propsRef.current.washFields
                });
            }
        };
    }, [
        ctxCondition,
        preserveContext
    ]);
    useEffect(()=>{
        propsRef.current.onSetContext?.(condition);
    }, [
        condition
    ]);
    return /*#__PURE__*/ _jsx(ConditionContext.Provider, {
        value: condition,
        children: children
    });
};
